<template>
    <div class="uniform-checker" :class="{'disabled': disabled}">
        <span :class="{
            'checked': modelValue,
        }">
            <input type="checkbox" class="form-check-input-styled" :disabled="disabled" :checked="modelValue" @change="$emit('update:modelValue', !modelValue)">
        </span>
    </div>
</template>
<script>
export default {
    name: 'AppCheckbox',
    props: {
        modelValue: {
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>